<template>
    <div id="download">
        <div class="download_box">
            <div class="title">
                <div class="t1">下载 CICADASING </div>
                <div class="t2">手机</div>
            </div>
            <div class="mobile_box">
                <div class="mobile">
                    <img src="../assets/img2/mobile_ios.png" alt="">
                    <div clsas="buttons">
                        <div><a :href="IOS_DOWNLOAD" class="button ios" style="margin-bottom:0;width: 150px;">苹果商店</a></div>
                        <div><a :href="ANDROID_DOWNLOAD" class="button android" style="margin-bottom:0;width: 150px;">谷歌商店</a></div>
                        <div><a :href="APK_DOWNLOAD" style="margin-bottom:0;width: 150px;" class="button apk" >Apk下载</a></div>
                        <!-- <span class="button android" :class="{show:showAndroid}" @click="showAndroid = !showAndroid">
                            Android 
                            <span class="el-icon-arrow-down"></span>
                            <span class="links">
                                <a :href="ANDROID_DOWNLOAD">Google store</a>
                                <a :href="APK_DOWNLOAD" download="Cicadasing">APK download</a>
                            </span>
                        </span> -->
                        <a id="linkToAndroid" style="display:none" href="znn://aa.bb:80/test?p=12&d=1">Link to App</a>
                    </div>
                </div>
                <!-- <div class="mobile">
                    <img src="../assets/img2/mobile_ios.png" alt="">
                    <div clsas="buttons">
                        <a :href="IOS_DOWNLOAD" class="button ios">Ios Store</a>
                    </div>
                </div> -->
            </div>
            <div class="desc1" v-if="!isMobile">
                在您手机上前往<a href="https://www.cicadasing.com/download">cicadasing.com/download</a>下载并安装。
            </div>
            <div class="desc2">安装CICADASING即代表您同意我们的 <a href="/ServiceTerms">服务条款与隐私政策</a>。</div>
        </div>


        <!-- <div class="downloads">
            <div class="info">
                <div class="download_logo" style="width: 100%;">
                    <img src="../assets/logo.png" alt="">
                </div>
                <div class="download_title">Cicadasing</div>
            </div>
            <div class="download_buttons">
                <a href="https://play.google.com/store/apps/details?id=com.chirping" class="download_button android">
                    <img src="../assets/android.png" alt="">
                </a>
                <a href="https://apps.apple.com/cn/app/%E8%9D%89%E9%B8%A3-%E8%87%AA%E7%94%B1%E7%A7%81%E5%AF%86%E7%9A%84%E8%81%8A%E5%A4%A9/id1531986175" class="download_button ios">
                    <img src="../assets/ios.png" alt="">
                </a>
            </div>
        </div> -->
    </div>
</template>
<style lang="scss" scoped>
#download{
    a{
        color: rgba(57,179,237,0.8);
        cursor: pointer;
        text-decoration: none;
    }
    a:hover{
        color: rgba(57,179,237,1);;
        text-decoration: underline;
    }
    .button{
        border-radius: 2px;
    }
    .android{
        cursor: pointer;
        color: rgba(57,179,237,0.8);
        text-decoration: none; 
        position: relative;
        .links{
            position:absolute;
            top:105%;
            left:0;
            width:100%;
            display:none;
            a{
                display:block;
                line-height:35px;
                background:#fff;
                border-radius: 2px;
                text-align: center;
            }
        }
        &.show{
            .el-icon-arrow-down{
                transform: rotate(180deg);
            }
            .links{
                display:inline-block;
            }
        }
    }
    // height:100vh;
    background: #edf8f5;
    width:100vw;
    // display:flex;
    // align-items: center;
    // justify-content: center;
    padding-top:6%;
    .download_box{
        max-width:600px;
        margin:auto;
        text-align: center;
        padding:5px;
        .title{
            .t1{
                color: rgba(0, 0, 0, .5);
                font-size: 12px;
                font-weight: 500;
                letter-spacing: .15em;
                line-height: 17px;
                margin-bottom: 7px;
                text-transform: uppercase;
            }
            .t2{
                font-size:29px;
                color:#1c1e21;                
                font-weight: 300;
                letter-spacing: .05em;
                line-height: 29px;
            }
        }
        .mobile_box{
            display:flex;
            justify-content: center;
            align-items: center;
            padding: 20px;
            .mobile{
                display:flex;
                flex-direction: column;
            }
            .button{
                margin-top:15px;
                margin-bottom:35px;
                line-height:35px;
                height:35px;
                padding-left:40px;
                box-shadow: 0px 1px 6px rgba(0, 33, 14, 0.05);
                &.android{
                    background:url("../assets/img2/android.png") no-repeat 15px center;
                    background-color:#fff;
                    background-size: 16px;
                }
                &.ios{
                    background:url("../assets/img2/ios.png") no-repeat 15px center;
                    background-color:#fff; 
                    background-size: 16px;
                }
                &.apk{
                    background:url("../assets/img2/apk.png") no-repeat 15px center;
                    background-color:#fff;
                    background-size: 20px;
                }
            }
        }
        .desc1{
            text-align: center;
            font-size: 24px;
            font-weight: 300;
        }
        .desc2{
            text-align: center;
            font-size: 15px;
            line-height: 21px;
        }
    }
}
.download_logo{text-align: center;}
.download_logo img{
    width:130px;
    margin-bottom:5px;
}
div.download_title{
    text-align: center;
    font-size:25px;
}
.download_buttons{
    margin-top: 30%;
}
a.download_button{
    display:block;
    margin:10px 0;
}
a.download_button img{
    width:169px;
}
@media screen and (max-width: 600px){
    #download{
        .mobile_box{
            flex-direction: column;
        }
    }
   .mobile{
       .buttons{
           display:flex;
           flex-direction: column;
           justify-content: center;
           align-items: center;
            .button{
                max-width: 150px;
                margin: 5px auto;
           }
       }
   }
}
@media screen and (max-width: 600px){
}
</style>
<script>
import {ANDROID_DOWNLOAD,IOS_DOWNLOAD,APK_DOWNLOAD} from "@/public/state";
function isMobile() {
  var userAgentInfo = navigator.userAgent;
 
  var mobileAgents = [ "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad","iPod"];
 
  var mobile_flag = false;
 
  //根据userAgent判断是否是手机
  for (var v = 0; v < mobileAgents.length; v++) {
      if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
      }
  }
 
   var screen_width = window.screen.width;
   var screen_height = window.screen.height;   
 
   //根据屏幕分辨率判断是否是手机
   if(screen_width < 500 && screen_height < 800){
       mobile_flag = true;
   }
 
   return mobile_flag;
}
export default {
    metaInfo: {
        title: 'Download',
        // meta: [
        //   {
        //     name: 'keywords',
        //     content: '关键字1,关键字2,关键字3'
        //   },
        //   {
        //     name: 'description',
        //     content: '这是一段网页的描述'
        //   }
        // ]
    },
    data(){
        return {
            showAndroid: false,
            ANDROID_DOWNLOAD,
            IOS_DOWNLOAD,
            APK_DOWNLOAD,
            isMobile: isMobile()
        }
    },
    created(){
        var Sys = {};
        var ua = navigator.userAgent.toLowerCase();
        var s;
        (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;
        //以下进行测试
        if (!Sys.safari){
            setTimeout(()=>{
                document.getElementById("linkToAndroid").click();
            },1000)
        };
    }
}
</script>